import React from "react"
import MyDateDayMonthYearFormField from "@common-components/fields/MyDateDayMonthYearFormField"
import MySelectFormField from "@common-components/fields/MySelectFormField"
import KpiHierarchySelectField from "./KpiHierarchySelectField"
import { CONST_API_UTILS_GET_HIERARCHY_PERSONNELS_OF_CONNECTED_USER_ENDPOINT } from "../../../../endpoints"
import { useKpiForm } from "./KpiContext"
import moment from "moment"

const KpiForm = () => {
     const { showForm, setShowForm, handleSubmit, isSubmitting, isValid, appliedValues, ...formik } = useKpiForm()

     const indicatorOptions = [
          {
               label: "Indicateurs Business",
               options: [
                    { value: "RENTABILITE", label: "Rentabilité" },
                    { value: "EFFECTIFS", label: "Évolution des effectifs" },
                    { value: "INTERCONTRATS", label: "Intercontrats / ETP" },
               ],
          },
     ]

     // VIEW MODE: Affichage récapitulatif après validation
     if (!showForm && appliedValues) {
          return (
               <div className="bg-light-info p-5 rounded mb-8 border border-info border-dashed d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-5">
                    <div className="d-flex flex-wrap gap-5 align-items-center">
                         {/* Période */}
                         <div className="d-flex flex-column">
                              <span className="text-muted fs-8 fw-bold text-uppercase">Période</span>
                              <span className="fw-bolder text-gray-800">
                                   Du {moment(appliedValues.dateDebut).format("DD/MM/YYYY")} au {moment(appliedValues.dateFin).format("DD/MM/YYYY")}
                              </span>
                         </div>

                         <div className="bullet bg-secondary h-25px w-1px d-none d-md-block"></div>

                         {/* Responsables */}
                         <div className="d-flex flex-column">
                              <span className="text-muted fs-8 fw-bold text-uppercase">Responsables</span>
                              <span className="fw-bolder text-gray-800">{appliedValues.responsables.length} sélectionné(s)</span>
                         </div>

                         <div className="bullet bg-secondary h-25px w-1px d-none d-md-block"></div>

                         {/* Indicateurs */}
                         <div className="d-flex flex-column">
                              <span className="text-muted fs-8 fw-bold text-uppercase">Indicateurs</span>
                              <div className="d-flex flex-wrap gap-1">
                                   {appliedValues.indicators.map(ind => (
                                        <span key={ind} className="badge badge-light-primary fs-8">
                                             {ind.replace(/_/g, " ")}
                                        </span>
                                   ))}
                              </div>
                         </div>
                    </div>

                    <button className="btn btn-sm btn-info fw-bold w-100 w-md-auto" onClick={() => setShowForm(true)}>
                         <i className="fas fa-edit me-2"></i>
                         Modifier les filtres
                    </button>
               </div>
          )
     }

     // WRITE MODE: Formulaire de sélection
     return (
          <div className="bg-light-primary p-7 rounded mb-8 border border-primary border-dashed">
               <form onSubmit={handleSubmit}>
                    <div className="row g-7 align-items-end">
                         <div className="col-12 col-md-6">
                              <MyDateDayMonthYearFormField
                                   label="Date Début"
                                   name="dateDebut"
                                   placeholder="01/01/2026"
                                   formikProps={formik as any}
                                   classNameLayout="mb-0"
                                   classNameLabel="fw-bold fs-6 mb-2"
                              />
                         </div>
                         <div className="col-12 col-md-6">
                              <MyDateDayMonthYearFormField
                                   label="Date Fin"
                                   name="dateFin"
                                   placeholder="31/12/2026"
                                   formikProps={formik as any}
                                   classNameLayout="mb-0"
                                   classNameLabel="fw-bold fs-6 mb-2"
                              />
                         </div>
                         <div className="col-12 col-md-6">
                              <KpiHierarchySelectField
                                   label="Responsables"
                                   name="responsables"
                                   endpoint={CONST_API_UTILS_GET_HIERARCHY_PERSONNELS_OF_CONNECTED_USER_ENDPOINT}
                                   formikProps={formik as any}
                                   classNameLayout="mb-0"
                              />
                              {formik.touched.responsables && formik.errors.responsables && (
                                   <div className="text-danger fs-7 mt-2 fw-bold">{formik.errors.responsables as string}</div>
                              )}
                         </div>
                         <div className="col-12 col-md-6">
                              <MySelectFormField
                                   label="Indicateurs"
                                   name="indicators"
                                   placeholder="Choisir..."
                                   options={indicatorOptions}
                                   isMulti={true}
                                   formikProps={formik as any}
                                   classNameLayout="mb-0"
                                   classNameLabel="fw-bold fs-6 mb-2"
                              />
                         </div>
                    </div>

                    <div className="separator separator-dashed my-6 opacity-25"></div>

                    <div className="d-flex justify-content-end gap-3">
                         {appliedValues && (
                              <button type="button" className="btn btn-sm btn-light" onClick={() => setShowForm(false)}>
                                   Annuler
                              </button>
                         )}
                         <button type="submit" className="btn btn-sm btn-primary w-100 w-md-auto" disabled={isSubmitting || !isValid}>
                              {!isSubmitting ? (
                                   <>
                                        <i className="fas fa-search me-2"></i>
                                        Générer les graphiques
                                   </>
                              ) : (
                                   <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                              )}
                         </button>
                    </div>
               </form>
          </div>
     )
}

export default KpiForm
